angular.module('TargetPerformanceNewState', [])
  .factory('TargetPerformanceNewState', function () {
    var openNewBuilder = false;

    return {
      requestNewBuilder: function () {
        openNewBuilder = true;
      },
      consumeNewBuilderRequest: function () {
        var requested = openNewBuilder;
        openNewBuilder = false;
        return requested;
      },
      hasPendingNewBuilderRequest: function () {
        return openNewBuilder;
      }
    };
  });